import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PaginationService {

  private pageIndexes: Map<string, number> = new Map();
  private pageSizes: Map<string, number> = new Map();

  setPageIndex(userId: string, pageIndex: number): void {
    this.pageIndexes.set(userId, pageIndex);
  }

  getPageIndex(userId: string): number {
    return this.pageIndexes.get(userId) || 0;
  }

  setPageSize(userId: string, pageSize: number): void {
    this.pageSizes.set(userId, pageSize);
  }

  getPageSize(userId: string): number {
    return this.pageSizes.get(userId) || 10;
  }
}
